import { Component, OnInit, Input, Output,EventEmitter,ElementRef,ViewChild,ChangeDetectionStrategy, HostListener, ChangeDetectorRef, ViewRef, OnDestroy} from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Options } from "@angular-slider/ngx-slider";
import { AppStateService } from 'src/app/core-module/services/app-state.service';
import { restore} from './../../../../assets/json/restoreTooltip.en';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: 'app-alo-slider',
  templateUrl: './alo-slider.component.html',
  styleUrls: ['./alo-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AloSliderComponent extends FieldType implements OnInit,OnDestroy {
@Input() field;
floorValue;
ceilValue;
defaultValue;
valOptions;
option:Options={
  floor:0,
  ceil:100,


};
textboxValue;
sliderValue;
mintextboxValue: Number;
minsliderValue;
maxsliderValue;
mindefaultValue;
aloMinSliderValue;
inputError: LegacyAny = [];
defaultColor = true;
minDefaultColor = true;
isAloEnabled;
isResetDisabled;
sliderChange=false;
val;
isSliderClick=true;
resetALoSlider: boolean;
newval: LegacyAny;
  showAloMinSlider: boolean;
  aloInputError: boolean;
  aloSliderValue: LegacyAny;
  quickConfigvalue;
  sliderQuick;
  setQuickConfig;
  isEnableFeature = false;
  restoreText = restore;
  fileResponse: LegacyAny;
  ng
  column: LegacyAny;
  properties: LegacyAny;
  aloPercentageOption: LegacyAny;
  aloPercentageMaximum: LegacyAny;
  aloPercentageMinimum: LegacyAny;
  aloMinLevelMinimum: LegacyAny;
  aloMinLevelMaximum: LegacyAny;
  aloMinLevelOption: LegacyAny;
  ngModelval: LegacyAny = {};
  aloMinlevelVal: LegacyAny;
  aloPercentageVal: LegacyAny;
  aloDefaultColor: boolean;
  aloDisbaled: boolean;
  aloDisbaledButton: boolean;
  wrongValue: LegacyAny;
  wrongAloMinValue: LegacyAny;
  quickConfigCustomCSS: string;
  aloPercentageDisplayValue: LegacyAny;
  aloMinLevelDisplayValue: LegacyAny;

  private aloPercentageInputSubject = new Subject<string>();
  private aloMinLevelInputSubject = new Subject<string>();

  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }

  ngOnInit() {
    this.featureDefaults.getAloDefaultValue.subscribe( (response) => {
      if(response) {
        this.resetSlider()
      }
    });

    // Guard: Ensure field schema is loaded before accessing properties
    if (!this.field || !this.field.properties) {
      // Initialize with safe defaults to prevent slider errors
      this.aloPercentageOption = { floor: 0, ceil: 100 };
      this.aloMinLevelOption = { floor: 0, ceil: 100 };
      this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue = 0;
      return;
    }

    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;

    // Additional guard: Ensure AloPercentage property exists
    if (!this.properties.AloPercentage) {
      // Initialize with safe defaults to prevent slider errors
      this.aloPercentageOption = { floor: 0, ceil: 100 };
      this.aloMinLevelOption = { floor: 0, ceil: 100 };
      this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue = 0;
      return;
    }

    this.aloPercentageMaximum = this.properties.AloPercentage.maximum;
    this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue = this.properties.AloPercentage.default;
    if(this.properties.AloMinLevel) {
      this.showAloMinSlider = true;
      this.aloPercentageMinimum = this.properties.AloMinLevel.minimum;
      this.aloMinLevelMaximum = this.properties.AloMinLevel.maximum;
      this.aloMinLevelMinimum = this.properties.AloMinLevel.minimum;
      this.aloMinLevelOption = {
        floor: this.aloMinLevelMinimum,
        ceil: this.aloMinLevelMaximum
      }
      this.ngModelval['AloMinLevelVal'] = this.aloMinlevelVal = this.aloMinLevelDisplayValue = this.properties.AloMinLevel.default;
      this.aloPercentageOption = {
        floor: this.aloPercentageMinimum,
        ceil: this.aloPercentageMaximum,
        minLimit: this.ngModelval['AloMinLevelVal']
      }
    } else {
      this.aloPercentageMinimum = this.properties.AloPercentage.minimum;
      this.aloPercentageOption = {
        floor: this.aloPercentageMinimum,
        ceil: this.aloPercentageMaximum
      }
    }

    this.ngModelval['AloEnabledVal'] = this.isEnableFeature = this.properties.AloEnabled.default;

    this.fileResponse = this.appState.getConfigurationData();
    const aaa = this.appState.getSaveSetData1();

    const readerInfo = this.appState.getReaderInfo();
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

     let  isConfigEdited = false;
     let featIndex:number=0;
     if(unSelectedFeat!=null){
      unSelectedFeat.forEach(element => {
        if(element["featureName"]==="ALO"){

          isConfigEdited = true;
          this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue = element["featureParameters"][0].AloPercentage;
          this.ngModelval['AloEnabledVal'] = this.isEnableFeature = element["featureParameters"][0].AloEnabled;

          if(this.field.properties.AloMinLevel) {
            if(this.properties.AloMinLevel) {
              const minLevel = element["featureParameters"][0].AloMinLevel;
              this.ngModelval['AloMinLevelVal'] = this.aloMinlevelVal = this.aloMinLevelDisplayValue =
                (minLevel != null) ? minLevel : this.properties.AloMinLevel.default;
            }
            this.aloPercentageOption = {
              floor: this.aloPercentageMinimum,
              ceil: this.aloPercentageMaximum,
              minLimit: this.ngModelval['AloMinLevelVal']
            }
          }
          unSelectedFeat.splice(featIndex,1)
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        }
        else{
          featIndex++;
        }

      });
    }
    if (isConfigEdited) {
      // no-op: config was already edited above; skip loading defaults so the else-if chain below is bypassed
    }
    // Check SaveSetData1 FIRST — it contains the latest user-configured values
    // and should take priority over ConfigurationData (which has initial device-read values).
    // Only skip this branch when we positively know the device is LCN9640; if readerInfo
    // is unavailable (e.g. after a page refresh) we still restore from saveSetData1.
    else if(aaa && aaa['resp'] && aaa['resp']['ALO'] && !(readerInfo && readerInfo[0] && readerInfo[0].peripheralType === 'LCN9640')) {
      this.fileResponse = aaa;
      const aloData = this.fileResponse.resp.ALO;
      this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue =
        aloData.AloPercentageVal ? aloData.AloPercentageVal : aloData.AloPercentage;
      this.ngModelval['AloEnabledVal'] = this.isEnableFeature =
        aloData.AloEnabledVal != null ? aloData.AloEnabledVal : aloData.AloEnabled;
      if(this.field.properties.AloMinLevel) {
        if(this.properties.AloMinLevel) {
          const minLevelVal = (aloData.AloMinLevelVal != null)
            ? aloData.AloMinLevelVal
            : ((aloData.AloMinLevel != null) ? aloData.AloMinLevel : this.properties.AloMinLevel.default);
          this.ngModelval['AloMinLevelVal'] = this.aloMinlevelVal = this.aloMinLevelDisplayValue = minLevelVal;
        }
        this.aloPercentageOption = {
          floor: this.aloPercentageMinimum,
          ceil: this.aloPercentageMaximum,
          minLimit: this.ngModelval['AloMinLevelVal']
        }
      }
    }
    // Fallback: use ConfigurationData (device-read values) if no user-configured data exists
    else if(this.fileResponse && this.fileResponse['resp'] && this.fileResponse['resp']['ALO']) {
      const aloResp = this.appState.getConfigurationData();
      this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.aloPercentageDisplayValue = this.fileResponse.resp.ALO.AloPercentage;
      this.ngModelval['AloEnabledVal'] = this.isEnableFeature = this.fileResponse.resp.ALO.AloEnabled;
      if(this.field.properties.AloMinLevel) {
        if(this.properties.AloMinLevel) {
          const configMinLevel = this.fileResponse.resp.ALO.AloMinLevel;
          this.ngModelval['AloMinLevelVal'] = this.aloMinlevelVal = this.aloMinLevelDisplayValue =
            (configMinLevel != null) ? configMinLevel : this.properties.AloMinLevel.default;
        }
        this.aloPercentageOption = {
          floor: this.aloPercentageMinimum,
          ceil: this.aloPercentageMaximum,
          minLimit: this.ngModelval['AloMinLevelVal']
        }
      }
      delete aloResp['resp']['ALO'];
      this.appState.setConfigurationData(aloResp);
    }
    this.aloAoc.aocSliderCick.subscribe(data=>{
      this.aloSliderValue = data['sliderClick'];
    })
    this.rSetChanged(this.isEnableFeature)
   this.aloAoc.getquickConfig.subscribe(data=>{
    if( data === 'quickConfig') {
      this.quickConfigvalue = true;
      this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
      // this.aloAoc.aloPercentConfigurationData({ 'AloPercentage': this.textboxValue });
      // this.apiService.setAloQuickData(this.mintextboxValue);
      this.setQuickConfig = 'quickConfig';
    } else if(data === 'standard') {
      this.quickConfigvalue = false;
      this.quickConfigCustomCSS = "custom-inputbox";
      // this.aloAoc.aloPercentConfigurationData({ 'AloPercentage': this.textboxValue });
      this.sliderValue = this.textboxValue;
      // this.apiService.setAloQuickData(this.mintextboxValue);
    }
    setTimeout(() => {
      if (this.ref && !(this.ref as ViewRef).destroyed) {
        this.ref.detectChanges();
      }
    });
  })

  setTimeout(() => {

    this.checkValidValue();
  },1000)

  this.aloPercentageDisplayValue = this.aloPercentageVal;
  this.aloMinLevelDisplayValue = this.aloMinlevelVal;

  this.aloPercentageInputSubject.pipe(
    debounceTime(100),
    distinctUntilChanged()
  ).subscribe(value => {
    this.validateAndUpdateField(value, 'aloPercentage');
  });

  this.aloMinLevelInputSubject.pipe(
    debounceTime(100),
    distinctUntilChanged()
  ).subscribe(value => {
    this.validateAndUpdateField(value, 'aloMinLevel');
  });

  }

  checkValidValue() {
    this.aloDefaultColor = false;
    this.aloDisbaledButton = false;
    if (this.aloPercentageVal < this.aloPercentageMinimum || this.aloPercentageVal > this.aloPercentageMaximum || this.aloPercentageVal < this.ngModelval['AloMinLevelVal']) {
      this.inputError['aloPercentage'] = true;
      this.aloDisbaledButton = true;
    }
    if (this.aloMinlevelVal < this.aloMinLevelMinimum || this.aloMinlevelVal > this.aloMinLevelMaximum) {
      this.inputError['aloMinLevel'] = true;
      this.aloDisbaledButton = true;
    }
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.aloDisbaledButton = true;
      }
    }
    this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
  }



  textValChanged(value, column) {
    if(value === '') {
      value = 0;
    }
    value = parseInt(value);
    this.aloDefaultColor = false;
    this.inputError[column] = false;
    this.aloDisbaledButton=false;
    if(column === 'aloPercentage') {
      if (value < this.aloPercentageMinimum || value > this.aloPercentageMaximum || value < this.ngModelval['AloMinLevelVal']) {
        this.inputError[column] = true;
        this.aloDisbaledButton=true;
        this.aloPercentageVal = value;
        this.wrongValue = value
      } else {
        this.ngModelval['AloPercentageVal'] = value;
        this.aloPercentageVal = value
      }
    } else if (column === 'aloMinLevel') {
      if (value < this.aloMinLevelMinimum || value > this.aloMinLevelMaximum) {
        this.inputError[column] = true;
        this.aloDisbaledButton=true;
        this.aloMinlevelVal = value;
        this.wrongAloMinValue = value
      } else {
        this.ngModelval['AloMinLevelVal'] = value;
        this.aloMinlevelVal = value;
        this.aloPercentageOption = {
          floor: this.aloPercentageMinimum,
          ceil: this.aloPercentageMaximum,
          minLimit: this.ngModelval['AloMinLevelVal']
        }
        // Preserve the alo percent textbox value when it is currently invalid
        // do not silently overwrite the user's typed value via aloPercentageSliderChange.
        if (this.inputError['aloPercentage']) {
          let newPercentageVal = this.aloPercentageVal;
          if (newPercentageVal < this.aloMinlevelVal) {
            newPercentageVal = this.aloMinlevelVal;
          }
          if (newPercentageVal > this.aloPercentageMaximum) {
            newPercentageVal = this.aloPercentageMaximum;
          }
          this.aloPercentageVal = newPercentageVal;
          this.ngModelval['AloPercentageVal'] = newPercentageVal;
        } else if (this.aloMinlevelVal >= this.aloPercentageVal || this.aloMinlevelVal >= this.ngModelval['AloPercentageVal']) {
          this.aloPercentageSliderChange(this.aloMinlevelVal);
        } else if (this.aloPercentageVal > this.aloPercentageMaximum) {
          this.aloPercentageSliderChange(this.aloPercentageMaximum);
        }
      }
    }
    this.checkDefault();
    for (const type in this.inputError) {
      if(this.inputError[type]) {
        this.aloDisbaledButton = true;
      }
    }
    this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
    this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
    this.aloAoc.setAloData(this.ngModelval);

  }
  onFieldInput(value: string, fieldName: string) {
    if (fieldName === 'aloPercentage') {
      this.aloPercentageDisplayValue = value;
      this.aloPercentageInputSubject.next(value);
    } else if (fieldName === 'aloMinLevel') {
      this.aloMinLevelDisplayValue = value;
      this.aloMinLevelInputSubject.next(value);
    }
    this.ref.detectChanges();
  }

  onFieldBlur(fieldName: string) {
    let value: string;
    if (fieldName === 'aloPercentage') {
      value = this.aloPercentageDisplayValue;
    } else if (fieldName === 'aloMinLevel') {
      value = this.aloMinLevelDisplayValue;
    }
    this.validateAndUpdateField(value, fieldName);
  }

  /**
   * Re-check the ALO % textbox against the RAW (possibly out-of-range) alo
   * min value the user just typed, and flag ALO % as error iff the visual
   * invariant ALO >= ALOmin is violated, or ALO is itself out of range.
   * Clears the ALO % error flag when both conditions are satisfied.
   */
  private revalidateAloPercentageAgainstRawMin(rawMin: number) {
    if (!this.showAloMinSlider) {
      return;
    }
    const rawPercentStr = this.aloPercentageDisplayValue;
    const rawPercent = parseFloat(rawPercentStr);
    if (isNaN(rawPercent)) {
      // Non-numeric input is already handled by the isNaN branch in
      // validateAndUpdateField; don't touch it here.
      return;
    }
    const outOfRange =
      rawPercent < this.aloPercentageMinimum ||
      rawPercent > this.aloPercentageMaximum ||
      rawPercent < rawMin;
    if (outOfRange) {
      this.inputError['aloPercentage'] = true;
      this.aloDisbaledButton = true;
    } else {
      this.inputError['aloPercentage'] = false;
    }
  }

  validateAndUpdateField(value: string, fieldName: string) {
    const numValue = parseFloat(value);
    if(isNaN(numValue)){
      this.inputError[fieldName]=true;
      this.aloDisbaledButton = true;
      this.aloDefaultColor = false;
      this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
      this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
      this.ref.detectChanges();
      return;
    }
    if (fieldName === 'aloPercentage') {
      let effectiveMinimum: number;
      if (this.showAloMinSlider) {
        const rawMin = parseFloat(this.aloMinLevelDisplayValue);
        effectiveMinimum = !isNaN(rawMin)
          ? rawMin
          : (this.ngModelval['AloMinLevelVal'] != null ? this.ngModelval['AloMinLevelVal'] : this.aloPercentageMinimum);
      } else {
        effectiveMinimum = this.aloPercentageMinimum;
      }
      if (numValue < this.aloPercentageMinimum || numValue > this.aloPercentageMaximum || numValue < effectiveMinimum) {
        this.inputError['aloPercentage'] = true;
        this.aloDisbaledButton = true;
        this.aloPercentageDisplayValue = value;
        this.wrongValue = value;
        const safeMin = Math.min(effectiveMinimum, this.aloPercentageMaximum);
        const clampedValue = Math.max(safeMin, Math.min(this.aloPercentageMaximum, numValue));
        this.ngModelval['AloPercentageVal'] = clampedValue;
        this.aloPercentageVal = clampedValue;
      } else {
        this.inputError['aloPercentage'] = false;
        this.ngModelval['AloPercentageVal'] = numValue;
        this.aloPercentageVal = numValue;
        this.aloPercentageDisplayValue = numValue;
        this.aloDisbaledButton = false;
      }
    } else if (fieldName === 'aloMinLevel') {
      if (numValue < this.aloMinLevelMinimum || numValue > this.aloMinLevelMaximum) {
        this.inputError['aloMinLevel'] = true;
        this.aloDisbaledButton = true;
        this.aloMinLevelDisplayValue = value;
        const clampedValue = Math.max(this.aloMinLevelMinimum, Math.min(this.aloMinLevelMaximum, numValue));
        this.ngModelval['AloMinLevelVal'] = clampedValue;
        this.aloMinlevelVal = clampedValue;
        // Cross-field: if the current ALO % textbox value is now less than the
        // raw (invalid) alo min the user just typed, flag ALO % as error too
        // the visual invariant ALO >= ALOmin must hold.
        this.revalidateAloPercentageAgainstRawMin(numValue);
      } else {
        this.inputError['aloMinLevel'] = false;
        this.ngModelval['AloMinLevelVal'] = numValue;
        this.aloMinlevelVal = numValue;
        this.aloMinLevelDisplayValue = numValue;
        this.aloPercentageOption = {
          floor: this.aloPercentageMinimum,
          ceil: this.aloPercentageMaximum,
          minLimit: this.ngModelval['AloMinLevelVal']
        };
        if (this.inputError['aloPercentage']) {
          let newPercentageVal = this.aloPercentageVal;
          if (newPercentageVal < this.aloMinlevelVal) {
            newPercentageVal = this.aloMinlevelVal;
          }
          if (newPercentageVal > this.aloPercentageMaximum) {
            newPercentageVal = this.aloPercentageMaximum;
          }
          this.aloPercentageVal = newPercentageVal;
          this.ngModelval['AloPercentageVal'] = newPercentageVal;
          // Re-check: with alo min now valid, the textbox might also become
          // valid (or stay invalid)  refresh the error flag accordingly.
          this.revalidateAloPercentageAgainstRawMin(numValue);
        } else if (this.aloMinlevelVal >= this.aloPercentageVal || this.aloMinlevelVal >= this.ngModelval['AloPercentageVal']) {
          this.aloPercentageSliderChange(this.aloMinlevelVal);
        } else if (this.aloPercentageVal > this.aloPercentageMaximum) {
          this.aloPercentageSliderChange(this.aloPercentageMaximum);
        }
        this.aloDisbaledButton = false;
      }
    }
    this.checkDefault();
    for (const type in this.inputError) {
      if(this.inputError[type]) {
        this.aloDisbaledButton = true;
      }
    }
    this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
    this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
    this.aloAoc.setAloData(this.ngModelval);

    this.ref.detectChanges();
  }

  aloPercentageSliderChange(value) {
    this.inputError['aloPercentage'] = false;
    if (value >= this.aloPercentageMinimum && this.inputError['aloPercentage'] === false) {
      this.ngModelval['AloPercentageVal'] = value;
      this.inputError['aloPercentage'] = false;
      this.aloPercentageVal = value;
      this.aloPercentageDisplayValue = value;
      this.aloDisbaledButton = false;
      for (const type in this.inputError) {
        if(this.inputError[type]) {
          this.aloDisbaledButton = true;
        }
      }
      this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
      this.checkDefault()
      this.aloAoc.setAloData(this.ngModelval);
      this.ref.detectChanges();
    }
  }

  aloMinValueChange(value) {
    this.inputError['aloMinLevel'] = false;
    if (value >= this.aloMinLevelMinimum && this.inputError['aloMinLevel'] === false) {
      this.ngModelval['AloMinLevelVal'] = value;
      this.inputError['aloMinLevel'] = false;
      this.aloMinlevelVal = value;
      this.aloMinLevelDisplayValue = value;
      this.aloPercentageOption = {
        floor: this.aloPercentageMinimum,
        ceil: this.aloPercentageMaximum,
        minLimit: this.ngModelval['AloMinLevelVal']
      }
      this.textValChanged(value, 'aloMinLevel')
      this.aloDisbaledButton = false;
      for (const type in this.inputError) {
        if(this.inputError[type]) {
          this.aloDisbaledButton = true;
        }
      }
      this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
      this.checkDefault()
      this.aloAoc.setAloData(this.ngModelval);
      this.ref.detectChanges();
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));

  }

  checkDefault() {
    this.aloDefaultColor = false;
    if (this.inputError['aloPercentage'] || this.inputError['aloMinLevel']) {
      this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
      return;
    }
    if(this.properties.AloMinLevel) {
      if((this.properties.AloMinLevel.default === this.aloMinlevelVal
        && this.properties.AloPercentage.default === this.aloPercentageVal)
        && (this.isEnableFeature === this.properties.AloEnabled.default)) {
        this.aloDefaultColor = true;
      }
    } else {
      if((this.properties.AloPercentage.default === this.aloPercentageVal)
      && (this.isEnableFeature === this.properties.AloEnabled.default)) {
      this.aloDefaultColor = true;
      }
    }
    this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
  }

  rSetChanged(value) {
    this.aloDefaultColor = value;
    this.isEnableFeature = this.ngModelval['AloEnabledVal'] = value
    this.aloDisbaled = !value;
    this.checkDefault();
    this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
    this.aloAoc.setAloData(this.ngModelval);
  }

  resetSlider() {
    this.aloDisbaledButton = false;
    this.inputError = {};
    if(this.properties.AloMinLevel) {
      this.ngModelval['AloMinLevelVal'] = this.aloMinlevelVal = this.properties.AloMinLevel.default;
      this.aloMinLevelDisplayValue = this.properties.AloMinLevel.default;
      this.aloMinLevelInputSubject.next(String(this.properties.AloMinLevel.default));
    }
    this.ngModelval['AloPercentageVal'] = this.aloPercentageVal = this.properties.AloPercentage.default;
    this.aloPercentageDisplayValue = this.properties.AloPercentage.default;
    this.aloPercentageInputSubject.next(String(this.properties.AloPercentage.default));
    this.ngModelval['AloEnabledVal'] = this.isEnableFeature = this.properties.AloEnabled.default;
    this.rSetChanged(this.isEnableFeature)
    for (const type in this.inputError) {
      if(this.inputError[type]) {
        this.aloDisbaledButton = true;
      }
    }
    this.aloDefaultColor = true;
    this.featureDefaults.setAloDefaultColor(this.aloDefaultColor);
    this.aloAoc.aloSetErrorButton(this.aloDisbaledButton);
    this.aloAoc.setAloData(this.ngModelval);
    setTimeout(() => {
      if (this.ref && !(this.ref as ViewRef).destroyed) {
        this.ref.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.textboxValue = 0;
    this.mintextboxValue = 0;
    this.minsliderValue = 0;
    this.sliderValue = 0;
    this.aloAoc.setAloData('');
    this.aloAoc.quickAloPercentConfigurationData('');
    this.aloAoc.aloPercentConfigurationData('');
    this.aloAoc.sentAloEnabled(false)
    this.aloAoc.aloSetErrorButton('');
  }
}
